import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e78dcf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex items-center justify-center",
  style: { height: '100vh', width: '100vw' }
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "px-34 py-20 rounded-12 font-semibold building-new" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "🧱"),
    /*#__PURE__*/_createElementVNode("div", { class: "ellipsis-animation" }, "building new workspace")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuthGuard = _resolveComponent("AuthGuard")!

  return (_openBlock(), _createBlock(_component_AuthGuard, {
    workspace: false,
    onValid: _ctx.handleValid
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["onValid"]))
}